module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/data/fp-commerce/shared-live/tmp/shop/node_modules/babel-loader/lib/index.js!/data/fp-commerce/shared-live/tmp/shop/client/generated/validation-8.js"));
    });
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/promise-loader?global!./generated/validation-8.js
 ** module id = 241
 ** module chunks = 20 21
 **/